export const LOCALISATION_UPDATE_SUCCESS =
  'jora-employer/localisation/LOCALISATION_UPDATE_SUCCESS';
